module.exports = __webpack_public_path__ + "static/media/关注主播-福利多多.5e9892e3.png";